import { AuthorisationsFormDesktopComponent } from 'src/app/user/authorisations/authorisations-desktop/authorisations-form/authorisations-form.component';
import { StorageService } from './../../../services/common/storage.service';
import { ParticleService } from './../../../services/particle/particle.service';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { AlertService } from 'src/app/services/common/alert.service';
import { CommandService } from 'src/app/services/common/command.service';
import { AccountSettingService } from 'src/app/services/user/account-setting.service';
import { AuthService } from 'src/app/services/user/auth.service';
import { PreferencesBase } from '../preferences.base';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'user-preferences-desktop',
    templateUrl: './preferences-desktop.component.html',
    styleUrls: ['./../preferences.component.scss', './preferences-desktop.component.scss'],
    standalone: false
})
export class PreferencesDesktopComponent extends PreferencesBase {

  public instIsValid: boolean;
  public hasInstructions: boolean;
  authChanged:boolean=false;

  constructor(
    accountSettingService: AccountSettingService,
    formBuilder: UntypedFormBuilder,
    router: Router,
    public commandService: CommandService,
    authService: AuthService,
    alertService: AlertService,
    public particleService: ParticleService,
    protected storageService: StorageService,
    public deviceService: DeviceDetectorService


  ) {
    super(accountSettingService, formBuilder, router, commandService, authService, alertService, particleService, storageService,deviceService);
  }

  setOutput(output) {
    this.instIsValid = output.confirmInstruction;
    this.instClear = output.clearInstruction;
  }
  setAuthorisation(output){
    this.authChanged =output.authorisationsFormChanged;
  }
}
